module.exports = __webpack_public_path__ + "static/img/lucre-games-indie-game-sacramento-logo-white.5825310.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lucre-games-indie-game-sacramento-logo-white.png
// module id = ffyJ
// module chunks = 0